import { ga4AffiliateClick } from "@/lib/ga4";

// Google Ads click conversion for outbound affiliate clicks.
// The base Google tag (AW-1000124803) is installed once in public/index.html and is reused here.
// Exactly ONE listener exists site-wide: a single delegated handler, so no affiliate link can be
// double counted by overlapping handlers. Navigation is never intercepted — no preventDefault, no
// window.location assignment — so target="_blank", middle clicks and slow networks are unaffected.
const SEND_TO = "AW-1000124803/hepyCIbDjJwdEIPj8twD";

// Guards against the same native click being processed twice (e.g. a stray second listener).
const reported = new WeakSet();

const isAffiliateAnchor = (a) => {
  if (!a?.href) return false;
  if (!a.relList?.contains("sponsored")) return false;
  try {
    return new URL(a.href, window.location.href).origin !== window.location.origin;
  } catch {
    return false;
  }
};

const handleClick = (event) => {
  // Right-clicks never navigate; only primary and middle (open-in-new-tab) clicks count.
  if (event.type === "click" && event.button > 1) return;
  const anchor = event.target?.closest?.("a[href]");
  if (!isAffiliateAnchor(anchor)) return;
  if (reported.has(event)) return;
  reported.add(event);
  window.gtag?.("event", "conversion", {
    send_to: SEND_TO,
    event_callback: () => {},
    event_timeout: 1000,
  });
  // Same click, reported to Analytics as an engagement signal (never as a sale).
  ga4AffiliateClick({
    merchant: anchor.dataset?.merchant,
    destination: anchor.href,
    placement: anchor.dataset?.testid || anchor.getAttribute("data-testid") || "link",
  });
};

export const initAffiliateConversionTracking = () => {
  document.addEventListener("click", handleClick, true);
  // Middle-click and some assistive activations never produce a "click" event.
  document.addEventListener("auxclick", handleClick, true);
  return () => {
    document.removeEventListener("click", handleClick, true);
    document.removeEventListener("auxclick", handleClick, true);
  };
};
